<template>
    <div>
        <img src="http://img.hxyou.cn/adf/202003/01/220048_31933_1" />
        <input @change="uploadInputchange"  id="uploadFileInput" type="file" accept="image/*">
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
      return {
      };
    },

    mounted() {
        console.log('ddsa');
        this.api.qiniuUpToken({forUuid:'23141-etwwf-5235-qwe41',root:'adf'},res=>{
            this.params.token=res.data.token;
            console.log(res.data);
        })
    },

    methods: {
        //触发input change事件
        uploadInputchange(){
            let file = document.getElementById("uploadFileInput").files[0];   //选择的图片文件

            this.api.qiniuUpToken({forUuid:'23141-etwwf-5235-qwe41',root:'adf'},res=>{
                this.uploadImgToQiniu(file,res.data);
                console.log(res.data);
            })


        },
        //上传图片到七牛
        uploadImgToQiniu(file,auth){
            const axiosInstance = axios.create({withCredentials: false});    //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
            let data = new FormData();
            data.append('token', auth.token);     //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
            data.append('file', file);
            if(auth.key) data.append('key',auth.key);
            axiosInstance({
                method: 'POST',
                url: auth.url,  //上传地址
                data: data,
                timeout:3600,      //超时时间，因为图片上传有可能需要很久
                onUploadProgress: (progressEvent)=> {
                    //imgLoadPercent 是上传进度，可以用来添加进度条
                    let imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                    console.log(imgLoadPercent);
                },
            }).then(data =>{
                //document.getElementById("uploadFileInput").value = ''
                console.log(data);
                //上传成功，把input的value设置为空，不然 无法两次选择同一张图片
                //上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
            }).catch(function(err) {
                //上传失败
            });
        }
    },
  }
</script>

<style>
</style>
